import React from 'react';
import { useSelector } from 'react-redux';
import {
  Autocomplete,
  TextField
} from '@mui/material';

const ListCellSelector = (props) => {
  const { id, value, field, api, selectorCallback } = props;

  // Get categories from the Redux store
  const categories = useSelector(selectorCallback);

  // Get the selected category object from the category ID
  const selectedCategory = categories.find(cat => cat.id === value) || null;

  const handleChange = (event, newValue) => {
    // Extract just the ID from the selected category
    const newCategoryId = newValue ? newValue.id : null;
    api.setEditCellValue({ id, field, value: newCategoryId });
  };

  return (
    <Autocomplete
      value={selectedCategory}
      onChange={handleChange}
      options={categories}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => <TextField {...params} variant="outlined" />}
      size="small"
      sx={{ width: '100%' }}
    />
  );
};
const ListCell = (props) => {
  const { value, selectorCallback } = props;

  // Get categories from Redux
  const customers = useSelector(selectorCallback);

  if (value === null || value === undefined) {
    return <div>None</div>;
  }

  const category = customers.find(cat => cat.id === value);
  return <div>{category ? category.name : `Unknown (${value})`}</div>;
};
const renderListCell = (params, selectorCallback) => {
  return <ListCell value={params.value} selectorCallback={selectorCallback} />;
};

export { renderListCell, ListCellSelector };
